<template>
  <sideBarView />

  <navbarView />

  <main class="main-sec" id="main">
    <div class="container">
      <div class="flex-bet-main mb-2">
        <div class="side-heading">
          <h6>{{ $t('MaintenanceDetails.title') }}</h6>
          <p class="font13 gray-col">
            {{ $t('MaintenanceDetails.subtitle') }}
          </p>
        </div>
      </div>
      <div class="card-details-def mb-3 shadow-main">
        <div class="flex-bet-main">
          <div class="font17 mb-3">
            {{ $t('MaintenanceDetails.orderNumber') }}: <span class="black">{{ orderNum }}</span>
          </div>
          <div class="gray-col normal-font mb-3">
            {{ $t('MaintenanceDetails.orderDate') }}: <span class="color-main">{{ orderdate }}</span>
          </div>
        </div>
        <div class="accordion-body font15 pt-0">
          <div class="gray-col normal-font mb-3">
            {{ $t('MaintenanceDetails.maintenanceType') }}: <span class="color-main">{{ orderTypeMaintan }}</span>
          </div>
          <div class="gray-col normal-font mb-3">
            {{ $t('MaintenanceDetails.orderStatus') }}:
            <span
              class="gray-col"
              :class="{
                greenColor: orderSatus == 'جديد' || orderSatus == 'New',
              }"
              >{{ orderSatus }}</span
            >
          </div>
          <div class="gray-col normal-font mb-1">{{ $t('MaintenanceDetails.problemDescription') }}:</div>
          <div class="mb-3">
            {{ desc }}
          </div>
          <div class="flex-sm-gap no-align mb-4">
            <div class="gray-col no-shrink">{{ $t('MaintenanceDetails.technician') }}:</div>
            <div class="content-all">
              <div class="flex-sm-gap mb-2">
                <div class="mb-2">{{ worker.name }}</div>
                <div class="rating-sm-box">
                  <i class="fa-solid fa-star orange-col"></i>
                  <div>{{ worker.rate }}</div>
                </div>
              </div>
              <div class="gray-col normal-font">
                {{ $t('MaintenanceDetails.phoneNumber') }}: <span>{{ worker.phone }}</span>
              </div>
            </div>
          </div>
          <div v-if="invoice">
            <div class="gray-col mb-2">{{ $t('MaintenanceDetails.orderInvoice') }}:</div>
            <div class="img-invoice">
              <Image :src="invoice" alt="Image" preview />
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup>
// imports
import sideBarView from "../components/dashboard/sideBarView.vue";
import navbarView from "../components/dashboard/navbarView.vue";
import Image from "primevue/image";
const route = useRoute();
import { useRoute } from "vue-router";
import axios from "axios";

import { onMounted, ref } from "vue";

// reactive state
const invoice = ref("");
const orderNum = ref("");
const orderdate = ref("");
const orderTypeMaintan = ref("");
const orderSatus = ref("");
const desc = ref("");
const worker = ref({});

// functions
function getOrder() {
  axios
    .get(`/manager/maintenance-order-details/${route.params.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      orderNum.value = response.data.data.id;
      invoice.value = response.data.data.invoice;
      orderdate.value = response.data.data.created_at;
      orderTypeMaintan.value = response.data.data.maintenance_type.name;
      orderSatus.value = response.data.data.status;
      desc.value = response.data.data.description;
      worker.value = response.data.data.worker;
    });
}

// lifecycle hooks
onMounted(() => {
  getOrder();
});
</script>
